<template>
  <BCard>

    <BTabs v-if="user" pills >

      <!-- Tab: Account -->
      <BTab active>
        <template #title>
          <feather-icon icon="UserIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">{{$t('Account')}}</span>
        </template>
        <UserEditTabAccount class="mt-2 pt-75" v-if="user" />
      </BTab>

    </BTabs>
  </BCard>
</template>

<script>
import { BTab, BTabs, BCard, BAlert, BLink, } from 'bootstrap-vue'
import { ref, onUnmounted, provide } from '@vue/composition-api'
import UserEditTabAccount from './UserEditTabAccount.vue'
import userStoreModule from '../userStoreModule'
import router from '@/router'
import store from '@/store'

export default {
  components: { BTab, BTabs, BCard, BAlert, BLink, UserEditTabAccount, },
  setup() {
    const permissions = ref(null)
    const USER_MODULE = 'users'
    const groups = ref(null)
    const roles = ref(null)
    const user = ref(null)

    provide('permissions', permissions)
    provide('groups', groups)
    provide('roles', roles)
    provide('user', user)

    if (!store.hasModule(USER_MODULE)) store.registerModule(USER_MODULE, userStoreModule)

    onUnmounted(() => { 
      if (store.hasModule(USER_MODULE)) store.unregisterModule(USER_MODULE) 
    })

    store.dispatch('users/editUser', { id: router.currentRoute.params.id }).then(response => {
        permissions.value = response.data.user.table_permissions
        groups.value = response.data.groups
        roles.value = response.data.roles
        user.value = response.data.user
      })

    return {
      user
    }
  },
}
</script>

<style>

</style>
